import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';
import LoginModal from '../features/auth/components/LoginModal';
import ParticlesBackground from '../features/auth/components/ParticlesBackground';
import ImagenProyecto from '../components/ImagenProyecto';
import HowItWorksSection from '../components/HowItWorksSection';
import BenefitsSection from '../components/BenefitsSection';
import MetricsSection from '../components/MetricsSection';
import EndorsementSection from '../components/EndorsementSection';
import Footer from '../components/Footer';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.role === 'Superuser') {
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/home-users', { replace: true });
      }
    }
  }, [isAuthenticated, user, navigate]);

  return (
    <div className="home-page-container">
      <ParticlesBackground />
      
      <div className="hero-section">
        <div className="contenido">
          <h1 className="titulo-degradado">Gestas ML</h1>
          <h2 className="subtitulo">Investigación y Desarrollo Universidad de Murcia</h2>
          <p className="descripcion">Motor de Predicción de Eficiencia Reproductiva Porcina</p>
          <div className="logo-portada-container">
           <a href="https://www.um.es/" target="_blank" rel="noopener noreferrer">
              <img src="/images/universidaddemurcia.svg" alt="Universidad de Murcia" className="um-logo" />
           </a>
            <a href="https://fseneca.es/" target="_blank" rel="noopener noreferrer">
              <img src="/images/fseneca.svg" alt="Fundación Séneca" className="seneca-logo" />
           </a>
           </div>
          <button onClick={() => setIsModalOpen(true)} className="boton-comenzar">
            Comenzar
          </button>
        </div>
      </div>

      <ImagenProyecto />
      <MetricsSection />
      <BenefitsSection />
      <HowItWorksSection />
      <EndorsementSection />
      <Footer onOpenLogin={() => setIsModalOpen(true)} />
      
      <LoginModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default HomePage;